import { GridOptions, ISetFilterParams } from '@ag-grid-community/core';

import { AgRawTooltip } from '@shared/components/ag-raw-tooltip/ag-raw-tooltip';
import { TableConstants } from '@shared/constants/table.constants';

export const DEFAULT_MANAGE_BALANCE_SHEETS_ACCOUNTS_GRID_CONFIG: GridOptions = {
  ...TableConstants.DEFAULT_GRID_OPTIONS.EDIT_GRID_OPTIONS,
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
    filter: true,
    filterParams: {
      showTooltips: true,
    } as ISetFilterParams,
    menuTabs: ['filterMenuTab'],
    minWidth: 100,
    resizable: true,
    sortable: true,
    suppressMenu: false,
    tooltipComponent: AgRawTooltip,
  },
  enableCellChangeFlash: true,
  enableFillHandle: true,
  enableRangeSelection: true,
  fillHandleDirection: 'y',
  // fillOperation: (params: FillOperationParams) => {
  //   const columnId = params.column.getColId();
  // },
  getRowId: ({ data }) => data.id,
  headerHeight: 48,
  noRowsOverlayComponent: TableConstants.NO_ROWS_MESSAGE,
  rowHeight: 40,
  rowSelection: 'multiple',
  // stopEditingWhenCellsLoseFocus: true,
  suppressAggFuncInHeader: true,
  suppressColumnVirtualisation: true,
  suppressMenuHide: true,
  suppressRowClickSelection: true,
  suppressRowTransform: true,
  tooltipShowDelay: 0,
};
